var $885879b9b10c2959$exports = {};
$885879b9b10c2959$exports = {
    "longPressMessage": `Pressione e segure ou pressione Alt + Seta para baixo para abrir o menu`
};


export {$885879b9b10c2959$exports as default};
//# sourceMappingURL=pt-BR.mjs.map
